import styles from './Image.module.scss';

export const IconImage: React.FC = () => {
    return (
        <span className={styles.icon}>
            <img title="icon" />
        </span>
    );
};
